import { useRouteMatch, Switch, Route } from "react-router";
import Ethnicity from "./Ethnicity";

const EthnicityRoot = (props) => {
  let { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}`} component={Ethnicity} />
      </Switch>
    </>
  );
};

export default EthnicityRoot;
